import React, { ReactElement, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import ClickAwayListener from 'react-click-away-listener';
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../reducers";
import useStyles from './styles';
import PromptComponent from "../PromptComponent";
import { setOpenPopup } from "../../actions/busyActions";

interface IFormProps {
    msg?: string;
    comp?: any;
    traitDisplay?: any;
    entity?: any;
    method?: any;
    mode?: string;
}

const Spinner: React.FC<IFormProps> = ({ msg, comp, traitDisplay, entity, method, mode }): ReactElement => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const { intl } = useSelector((state: AppState) => state.intl);

    const [display, setDisplay] = useState(true);

    const { sizeSideBar } = useSelector((state: AppState) => state.busy);

    const { t } = useTranslation();

    const handleClickAway = () => {
        setDisplay(false);
        traitDisplay(false);
        dispatch(setOpenPopup(false));
    };    

    return (
        <>
            {sizeSideBar && display && <div className={classes.ctnLoader} style={intl === 'ar' ? { left: 0, width: `${sizeSideBar}px` } : { right: 0, width: `${sizeSideBar}px` }}>
                {comp === 'delete' ?
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <PromptComponent handleClickAway={handleClickAway} infoEntity={entity} method={method} mode={mode} />
                    </ClickAwayListener> :
                    <div className={classes.ctnSpinner}>
                        <div className={classes.loader} /><div style={{ color: 'white', whiteSpace: 'nowrap', float: 'right', marginTop: '12px' }}>{msg || t("loading_message")}</div>
                    </div>}
            </div>}
        </>
    )
}

export default memo(Spinner);